const FolioConverter = {
  ToString: function (catProcesoId, procesoId) {
    return `CD-${catProcesoId.toString().padStart(2, '0')}-${procesoId.toString().padStart(6, '0')}`;
  },

  ToTuple: function (folio) {
    if (!/^CD-\d{2}-\d{6}$/.test(folio)) {
      throw new Error("Invalid argument format.");
    }

    const parts = folio.split('-');

    return {
      catProcesoId: parseInt(parts[1]),
      procesoId: parseInt(parts[2])
    };
  }
};

export default FolioConverter;
